import resolveConfig from 'tailwindcss/resolveConfig';
import { useMemo } from 'react';
import tailwindConfig from '../../tailwind.config.js';

export const useTailwindTheme = () => {
  const fullConfig = useMemo(() => resolveConfig(tailwindConfig), []);
  return fullConfig.theme;
};
